'use strict';

import { SELF_SERVICE_BASE } from './studyBuilder.config.js';

/**
 * Human-readable summary of stats + interpretation choices.
 * @param {{ statsServices?: string|null, interpretationLevel?: string|null }} s
 * @returns {string}
 */
export function summarizeServiceSelection(s) {
	const parts = [`${SELF_SERVICE_BASE.label} — included`];
	if (s.statsServices !== 'yes' && s.statsServices !== 'no') {
		return parts.join(' · ');
	}
	if (s.statsServices === 'yes') {
		parts.push('Statistics: Yes');
		if (s.interpretationLevel === 'none') parts.push('Interpretation: None');
		else if (s.interpretationLevel === 'standard') parts.push('Interpretation: Standard');
		else if (s.interpretationLevel === 'advanced') parts.push('Interpretation: Advanced');
	} else if (s.statsServices === 'no') {
		parts.push('Statistics: No (data-focused)');
	}
	return parts.join(' · ');
}
